/**
 * @class
 * @hideconstructor
 */
function AuxillaryServices() {}

/** @type {object} */
AuxillaryServices.m_Services = {};

/** @type {Array<Function>} */
AuxillaryServices.m_Callbacks = [];

/**
 *
 * @param {*} discoveryCb
 * @todo document this
 */
AuxillaryServices.Discover = function (discoveryCb) {
    AuxillaryServices.m_DiscoveryCallback = discoveryCb;
    AuxillaryServices.m_DiscoveryCallbackFired = false;
    AuxillaryServices.m_InitializeCalled = false;

    if (!AuxillaryServices.m_InitializeCalled) {
        AuxillaryServices.m_InitializeCalled = true;

        AuxillaryServices.m_Callbacks.forEach(function (cb) {
            cb('Initialize');
        });
    }

    AuxillaryServices.m_Callbacks.forEach(function (cb) {
        cb('DiscoveryFailed', null);
    });

    if (!AuxillaryServices.m_DiscoveryCallbackFired) {
        AuxillaryServices.m_DiscoveryCallbackFired = true;
        if (typeof AuxillaryServices.m_DiscoveryCallback != 'undefined') {
            AuxillaryServices.m_DiscoveryCallback();
        }
    }
};

/**
 *
 * @param {*} name
 * @todo document this
 */
AuxillaryServices.Service = function (name) {
    if (typeof AuxillaryServices.m_Services[name] == 'undefined') {
        return null;
    }

    return AuxillaryServices.m_Services[name];
};

/**
 *
 * @param {*} name
 * @param {*} svcImpl
 * @todo document this
 */
AuxillaryServices.RegisterService = function (name, svcImpl) {
    AuxillaryServices.m_Services[name] = svcImpl;
};

/**
 *
 * @param {*} cb
 * @todo document this
 */
AuxillaryServices.AddListener = function (cb) {
    AuxillaryServices.m_Callbacks.push(cb);
};

export { AuxillaryServices as Aux };
